<template>
  <v-text-field
    v-mask="'##.##.####'"
    :value="formattedDate"
    name="birthday"
    :error-messages="errorMessages"
    hint="##.##.####"
    :label="$t('PROFILE.BIRTH_DATE')"
    append-icon="mdi-calendar"
    :clearable="!readonly"
    :rules="birthdayRules"
    :readonly="readonly"
    v-bind="$attrs"
    @click:clear="clearBirthday"
    @input="emitter"
  />
</template>

<script>
import { mask } from 'vue-the-mask';
import moment from 'moment';
import { dateFormat, dateFormatBackend } from '@/modules/_global/filters';
import { textLine } from '@/modules/_global/variables/rules';

export default {
  name: 'BirthdayInput',

  filters: {
    dateFormat,
    dateFormatBackend
  },

  directives: {
    mask
  },

  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => textLine
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    formatDate: 'DD.MM.YYYY'
  }),

  computed: {
    birthdayRules() {
      return [...this.rules, this.validateBirthday];
    },

    formattedDate() {
      return this.isValidBirthday(dateFormat(this.value))
        ? dateFormat(this.value)
        : this.value;
    }
  },

  methods: {
    validateBirthday(value) {
      if (!value) {
        return true;
      }

      return this.isValidBirthday(value) || this.$t('MESSAGE.INVALID_DATE');
    },

    emitter(value) {
      if (this.value === value) {
        return;
      }

      if (!value) {
        this.$emit('input', null);
      }

      if (this.isValidBirthday(value)) {
        this.$nextTick(() => {
          this.$emit(
            'input',
            dateFormatBackend(moment(value, this.formatDate))
          );
        });
      }
    },

    isValidBirthday(value) {
      if (!value) {
        return false;
      }
      return (
        moment(value, this.formatDate, true).isValid() &&
        moment(value, this.formatDate).isBetween('1900-01-01', moment())
      );
    },
    clearBirthday() {
      this.emitter(null);
    }
  }
};
</script>
